// src/components/LoggedIn/Dashboard.jsx
import React, { useState } from "react";
import {
  MenuOutlined,
  HomeOutlined,
  BarChartOutlined,
  UserOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import UserDetails from "../User/UserDetails";
import UserInventories from "../User/UserInventories";
import UserSales from "../User/UserSales";
import DashboardGraphics from "./DashboardGraphics"
import UserMovements from "../User/UserMovements";
import InicioContent from "./InicioContent";
import LogoutButton from "./LogoutButton";
import "../../styles/Dashboard.css";

export default function Dashboard() {
  const [menuActivo, setMenuActivo] = useState("inicio");
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible((prev) => !prev);
  };

  // Array de items con su clave, etiqueta y el componente Icon
  const menuItems = [
    { key: "inicio", label: "Inicio", icon: <HomeOutlined /> },
    { key: "estadisticas", label: "Estadísticas y Gráficas", icon: <BarChartOutlined /> },
    { key: "perfil", label: "Mi Perfil", icon: <UserOutlined /> },
    { key: "inventario", label: "Mi Inventario y productos", icon: <AppstoreOutlined /> },
    { key: "ventas", label: "Mis ventas", icon: <ShoppingCartOutlined /> },
    { key: "movimientos", label: "Historial de movimientos mi inventario", icon: <HistoryOutlined /> },
  ];

  return (
    <div className="dashboard-container">
      <button className="menu-toggle" onClick={toggleMenu}>
        <MenuOutlined />
      </button>

      <aside className={`sidebar ${menuVisible ? "visible" : "hidden"}`}>
        <div className="sidebar-header">Dashboard</div>
        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li
                key={item.key}
                className={`menu-item ${menuActivo === item.key ? "active" : ""}`}
                onClick={() => {
                  setMenuActivo(item.key);
                  setMenuVisible(false);
                }}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-label">{item.label}</span>
              </li>
            ))}
          </ul>
        </nav>
        <LogoutButton />
      </aside>

      <main className="main-content">
        {/* ← Solo mostramos este bloque cuando menuActivo === "inicio" */}
        {menuActivo === "inicio" && (
          <div className="dashboard-welcome">
            <h1>👋 ¡Hola! Bienvenido a tu Panel de Control</h1>
            <p>Navegación:</p>
            <ul className="dashboard-guide">
              <li>
                <strong>Inicio:</strong> Vista general e instrucciones.
              </li>
              <li>
                <strong>Estadísticas:</strong> Gráficas e insights (muy pronto).
              </li>
              <li>
                <strong>Mi Perfil:</strong> Datos personales registrados.
              </li>
              <li>
                <strong>Mis Ventas:</strong> Historial de productos vendidos.
              </li>
              <li>
                <strong>Movimientos:</strong> Visualización de cambios en inventario.
              </li>
              <li>
                <strong>Mi Inventario:</strong> Listado completo de tus productos.
              </li>
            </ul>
          </div>
        )}

        <div className="content">
          {menuActivo === "inicio" && <InicioContent />}
          {menuActivo === "estadisticas" && <DashboardGraphics/>}
          {menuActivo === "perfil" && (
            <div className="user-details">
              <UserDetails />
            </div>
          )}
          {menuActivo === "inventario" && (
            <div className="user-inventories">
              <UserInventories />
            </div>
          )}
          {menuActivo === "ventas" && (
            <div className="user-sales">
              <UserSales />
            </div>
          )}
          {menuActivo === "movimientos" && (
            <div className="user-movements">
              <UserMovements />
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
